import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledStatsHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledDefaultText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledStatsIcon = styled(FontAwesomeIcon)`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledStatsHeading = styled.span`
  font-size: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledStatsOptionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2.4rem;
`;

export const StyledSearchIcon = styled(FontAwesomeIcon)<{ isDarkMode: boolean }>`
  && {
    color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.grey[400] : theme.colors.grey[700])};
  }
`;

export const StyledDownloadButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  flex-basis: 25.9rem;
`;

export const StyledDownloadIcon = styled(FontAwesomeIcon)`
  && {
    height: 1.9rem;
    width: 1.6rem;
    color: ${({ theme }) => theme.colors.grey[600]};
  }
`;

export const StyledSearchTextInputContainer = styled.div`
  flex-basis: 45.2rem;
  flex-grow: 1;
`;

export const StyledPaginationRecordsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex-grow: 1;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
`;

export const StyledRecordsWrapper = styled.div`
  flex-basis: 22rem;
`;

// TODO [TI-1057] [2024-01-01] - Replace these mitigations when issues with ModularTable are resolved.
export const StyledStatsModularTableWrapper = styled.div`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;

  div[role='table'] {
    overflow: unset;
    border-radius: ${({ theme }) => theme.radius.small};
    border: 0.1rem solid ${({ theme }) => theme.colors.border.main};
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      box-shadow: none;
    }
  }
  div[role='row'] {
    position: relative;
    transition: background-color 0.2s linear;
    padding: 3rem 0.5rem;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      border: none;
      :not(:first-child) {
        border-top: 0.1rem solid ${({ theme }) => theme.colors.border.light};
      }
      :first-child:has(div[role='cell']) {
        border-top-right-radius: ${({ theme }) => theme.radius.small};
        border-top-left-radius: ${({ theme }) => theme.radius.small};
      }
    }
    @media (min-width: ${({ theme }) => theme.sizes.md}) {
      padding: 0;
      :first-child:has(div[role='columnheader']) {
        border-top-right-radius: ${({ theme }) => theme.radius.small};
        border-top-left-radius: ${({ theme }) => theme.radius.small};
      }
    }
    :last-child:has(div[role='cell']) {
      border-bottom-right-radius: ${({ theme }) => theme.radius.small};
      border-bottom-left-radius: ${({ theme }) => theme.radius.small};
    }
  }
  div[role='cell'] {
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      padding: 1rem;
      > div {
        flex: 1;
        :first-child {
          display: flex;
          align-items: center;
          margin-right: 1rem;
          flex: 0 1 40%;
        }
      }
    }
  }
`;

export const StyledUserAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledRecordDetailText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledPaginationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
    gap: 2.4rem;
  }
`;
